import { compose, applyMiddleware, createStore, combineReducers } from 'redux'
import thunk from 'redux-thunk'

import reducers from './reducers'

const composedStore = (devTools) => (
	(
		devTools ?
			compose(
				applyMiddleware(thunk),
				devTools
			)(createStore) :
			compose(
				applyMiddleware(thunk)
			)(createStore)
	)
)


function configureStore(initialState, devTools) {
	const combinedReducers = combineReducers(reducers)
	const store = composedStore(devTools)(combinedReducers, initialState)

	if (module.hot) {
		// Enable Webpack hot module replacement for combinedReducers
		module.hot.accept(combinedReducers, () => {
			store.replaceReducer(combinedReducers)
		})
	}

	return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/store.js